import { render, staticRenderFns } from "./CardDadosPrincipaisObservador.vue?vue&type=template&id=ee388556"
import script from "./CardDadosPrincipaisObservador.vue?vue&type=script&lang=js"
export * from "./CardDadosPrincipaisObservador.vue?vue&type=script&lang=js"
import style0 from "./CardDadosPrincipaisObservador.vue?vue&type=style&index=0&id=ee388556&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports